import gql from "graphql-tag";

export const GET_PHOTO_ROYALTIES_STATEMENT_ALL = gql`
    query photoRoyaltyStatementsAndTotal {
        photoRoyaltyStatementsAndTotal {
            ok
            errors
            statements {
                items {
                    month
                    totalEarned
                    totalPaid
                    insightsExist
                    freeDownloadCount
                    largeSales
                    fullResSales
                    pdfDownloadUrl
                }
                totalCount
            }
            totals: total {
                totalEarned
                totalPaid
                freeDownloadCount
                fullResSales
                largeSales
            }
        }
    }
`;
